import './styles.scss'
import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import { getSchedule, setSchedule } from './scheduleHelper'
import Grid from './Grid.js'
import { Button } from 'components/Form'

const Basic = (props) => {
  const [gridSchedule, setGridSchedule] = React.useState(getSchedule(props.schedules))

  const cicleTileStatus = (dayIndex, rangeIndex) => {
    return new Promise((resolve) => {
      let newSchedule = gridSchedule
      if (newSchedule[dayIndex].ranges[rangeIndex] < 3) {
        newSchedule[dayIndex].ranges[rangeIndex]++
      } else {
        newSchedule[dayIndex].ranges[rangeIndex] = 0
      }
      setGridSchedule(newSchedule)
      resolve()
    })
  }

  const saveSchedule = () => {
    const translatedSchedules = setSchedule(gridSchedule)

    const schedule1 = translatedSchedules[0]
    const schedule2 = translatedSchedules[1]
    const schedule3 = translatedSchedules[2]

    schedule1.isActive = Object.values(schedule1).findIndex(elem => elem.isActive) !== -1
    schedule1.timeZone = props.schedules[0].timeZone

    schedule2.isActive = Object.values(schedule2).findIndex(elem => elem.isActive) !== -1
    schedule2.timeZone = props.schedules[1].timeZone

    schedule3.isActive = Object.values(schedule3).findIndex(elem => elem.isActive) !== -1
    schedule3.timeZone = props.schedules[2].timeZone

    props.saveSchedules(schedule1, schedule2, schedule3).then(() => {
      props.closeModal()
    })
  }

  return(
    <div className='schedule-modal-basic'>
      <div className='modal-header'>
        <div className='title-container'>
          <div className='title'>{I18n.t('faq_console_schedule_modal_title_bot')}</div>
          <div className='subtitle'>{I18n.t('faq_console_schedule_modal_subtitle_tiles')}</div>
        </div>
        <div className='close-container' onClick={props.closeModal}>
          <i className='fa fa-times'></i>
        </div>
      </div>
      <div className='color-title-container'>
        <div className='color-title'>
          <div className='tile-container'>
            <div className='tile' style={{ backgroundColor: '#f59528' }} />
          </div>
          <div className='title'>
            {I18n.t('dashboard_automatic-responses')}
          </div>
        </div>
        <div className='color-title'>
          <div className='tile-container'>
            <div className='tile' style={{ backgroundColor: '#dd601d' }} />
          </div>
          <div className='title'>
            {I18n.t('dashboard_operator-assistance')}
          </div>
        </div>
        <div className='color-title'>
          <div className='tile-container'>
            <div className='tile' style={{ backgroundColor: '#2c2d2d' }} />
          </div>
          <div className='title'>
            {I18n.t('dashboard_smartchat')}
          </div>
        </div>
        <div className='color-title'>
          <div className='tile-container'>
            <div className='tile' style={{ backgroundColor: '#F1F1F1' }} />
          </div>
          <div className='title'>
            {I18n.t('dashboard_disabled')}
          </div>
        </div>
      </div>
      <div className='schedule-container'>
        <div className='grid-container'>
          <div className='grid'>
            <Grid schedule={gridSchedule} cicleTileStatus={cicleTileStatus}/>
          </div>
        </div>
      </div>
      <div className='modal-footer'>
        <div className='action-buttons'>
          <Button secondary value={I18n.t('dashboard_save')} onClick={saveSchedule} />
          <Button value={I18n.t('dashboard_cancel')} onClick={props.closeModal} />
        </div>
        <div className='schedule-mode-button' onClick={props.toggleMode}>
          <i className='fa fa-clock-o fa-lg'></i>
          {I18n.t('dashboard_advanced-method')}
        </div>
      </div>
    </div>
  )
}

export default Basic